/**
 * Please note:
 *
 * Translations are provided as an illustration only and are
 * not guaranteed to be accurate or error-free.
 *
 * They are designed to show developers where to store their
 * chosen phrase or spelling variant in the target language.
 */

export const AG_CHARTS_LOCALE_FA_IR: Record<string, string> = {
    ariaAnnounceChart: 'چارت، ${seriesCount}[number] مجموعه',
    ariaAnnounceFlowProportionLink: 'لینک ${index} از ${count}، از ${from} به ${to}، ${sizeName} ${size}',
    ariaAnnounceFlowProportionNode: 'گره ${index} از ${count}، ${description}',
    ariaAnnounceGaugeChart: 'چارت سنجشی، ${caption}',
    ariaAnnounceHierarchyChart: 'نمودار سلسله مراتبی، ${caption}',
    ariaAnnounceHierarchyDatum: 'سطح ${level}[number]، ${count}[number] فرزند، ${description}',
    ariaAnnounceHoverDatum: '${datum}',
    ariaDescriptionLegendItem: 'برای تغییر قابل مشاهده بودن، اسپیس یا اینتر را فشار دهید',
    ariaLabelAddHorizontalLine: 'افزودن خط افقی',
    ariaLabelAnnotationOptionsToolbar: 'گزینه‌های حاشیه‌نویسی',
    ariaLabelAnnotationSettingsDialog: 'تنظیمات حاشیه نویسی',
    ariaLabelColorPicker: 'انتخاب‌گر رنگ',
    ariaLabelFinancialCharts: 'نمودارهای مالی',
    ariaLabelLegend: 'راهنما',
    ariaLabelLegendItem: '${label}، مورد فهرست ${index}[number] از ${count}[number]',
    ariaLabelLegendItemUnknown: 'مورد ناشناخته در فهرست علائم',
    ariaLabelLegendPageNext: 'صفحه بعدی راهنما',
    ariaLabelLegendPagePrevious: 'صفحه قبلی افسانه',
    ariaLabelLegendPagination: 'صفحه‌بندی راهنما',
    ariaLabelNavigator: 'جهت‌یاب',
    ariaLabelNavigatorMaximum: 'حداکثر',
    ariaLabelNavigatorMinimum: 'حداقل',
    ariaLabelNavigatorRange: 'محدوده',
    ariaLabelRangesToolbar: 'محدوده‌ها',
    ariaLabelSettingsTabBar: 'تنظیمات',
    ariaLabelZoomToolbar: 'بزرگنمایی',
    ariaValuePanRange: '${min}[percent0to2dp] تا ${max}[percent0to2dp]',
    contextMenuDownload: 'دانلود',
    contextMenuPanToCursor: 'حرکت به اینجا',
    contextMenuToggleOtherSeries: 'تغییر وضعیت سایر سری‌ها',
    contextMenuToggleSeriesVisibility: 'تغییر نمایش',
    contextMenuZoomToCursor: 'زوم به اینجا',
    dialogHeaderChannel: 'کانال',
    dialogHeaderDatePriceRange: 'تاریخ و قیمت',
    dialogHeaderDateRange: 'بازه زمانی',
    dialogHeaderFibonacciRange: 'فیب بازگشت',
    dialogHeaderLine: 'خط',
    dialogHeaderPriceRange: 'بازه قیمتی',
    dialogHeaderText: 'متن',
    dialogInputAlign: 'تراز',
    dialogInputColorPicker: 'رنگ',
    dialogInputColorPickerAltText: 'رنگ متن',
    dialogInputExtendAbove: 'گسترش بالا',
    dialogInputExtendBelow: 'تحتانی گسترش یابد',
    dialogInputExtendChannelEnd: 'گسترش انتهای کانال',
    dialogInputExtendChannelStart: 'تمدید شروع کانال',
    dialogInputExtendLeft: 'گسترش به چپ',
    dialogInputExtendLineEnd: 'ادامه خط پایان',
    dialogInputExtendLineStart: 'گسترش شروع خط',
    dialogInputExtendRight: 'ادامه به راست',
    dialogInputFibonacciBands: 'باندها',
    dialogInputFibonacciBandsAltText: 'باندهای فیبوناچی',
    dialogInputFillColorPicker: 'پر کردن',
    dialogInputFillColorPickerAltText: 'رنگ پر کردن',
    dialogInputFontSize: 'اندازه',
    dialogInputFontSizeAltText: 'اندازه فونت',
    dialogInputLineStyle: 'خط چین',
    dialogInputPosition: 'موقعیت',
    dialogInputReverse: 'برعکس',
    dialogInputShowFill: 'نمایش پر کردن',
    dialogInputStrokeWidth: 'وزن',
    dialogInputStrokeWidthAltText: 'وزن خط',
    iconAltTextAlignCenter: 'وسط',
    iconAltTextAlignLeft: 'چپ',
    iconAltTextAlignRight: 'راست',
    iconAltTextClose: 'بستن',
    iconAltTextLineStyleDashed: 'خط-چین بلند',
    iconAltTextLineStyleDotted: 'خط با خط‌چین کوتاه',
    iconAltTextLineStyleSolid: 'یکدست',
    iconAltTextPositionBottom: 'پایین',
    iconAltTextPositionCenter: 'مرکز',
    iconAltTextPositionTop: 'بالا',
    inputTextareaPlaceholder: 'اضافه کردن متن',
    measurerDateRangeBars: '${value}[number] میله‌ها',
    measurerPriceRangePercent: '${value}[percent]',
    measurerPriceRangeValue: '${value}[number]',
    measurerVolume: 'حجم ${value}',
    overlayLoadingData: 'در حال بارگذاری داده...',
    overlayNoData: 'داده‌ای برای نمایش وجود ندارد',
    overlayNoVisibleSeries: 'سری قابل مشاهده‌ای وجود ندارد',
    overlayUnsupportedBrowser: 'نسخه مرورگر ناسازگار است. لطفاً مرورگر خود را به‌روزرسانی کنید.',
    seriesHistogramTooltipCount: '${yName} (تعداد)',
    seriesHistogramTooltipFrequency: 'بسامد',
    seriesHistogramTooltipMean: '${yName} (میانگین)',
    seriesHistogramTooltipSum: '${yName} (مجموع)',
    toolbarAnnotationsArrow: 'پیکان',
    toolbarAnnotationsArrowDown: 'پیکان پایین',
    toolbarAnnotationsArrowUp: 'پیکان بالا',
    toolbarAnnotationsCallout: 'یادداشت',
    toolbarAnnotationsClearAll: 'پاک کردن همه',
    toolbarAnnotationsComment: 'نظر',
    toolbarAnnotationsDatePriceRange: 'تاریخ و قیمت',
    toolbarAnnotationsDateRange: 'بازه زمانی',
    toolbarAnnotationsDelete: 'حذف',
    toolbarAnnotationsDisjointChannel: 'کانال جداگانه',
    toolbarAnnotationsDragHandle: 'دسته ابزار را بکشید',
    toolbarAnnotationsFibonacciAnnotations: 'فیبوناچی',
    toolbarAnnotationsFibonacciRetracement: 'فیب بازگشتی',
    toolbarAnnotationsFibonacciRetracementTrendBased: 'روند فیب بر اساس',
    toolbarAnnotationsFillColor: 'رنگ پر کردن',
    toolbarAnnotationsHorizontalLine: 'خط افقی',
    toolbarAnnotationsLineAnnotations: 'خطوط روند',
    toolbarAnnotationsLineColor: 'رنگ خط',
    toolbarAnnotationsLineStrokeWidth: 'عرض خط قلم',
    toolbarAnnotationsLineStyle: 'سبک خط',
    toolbarAnnotationsLock: 'قفل کردن',
    toolbarAnnotationsMeasurerAnnotations: 'ابزار اندازه‌گیری',
    toolbarAnnotationsNote: 'توجه',
    toolbarAnnotationsParallelChannel: 'کانال موازی',
    toolbarAnnotationsPriceRange: 'محدوده قیمت',
    toolbarAnnotationsQuickDatePriceRange: 'اندازه‌گیری',
    toolbarAnnotationsSettings: 'تنظیمات',
    toolbarAnnotationsShapeAnnotations: 'پیکان‌ها',
    toolbarAnnotationsText: 'متن',
    toolbarAnnotationsTextAnnotations: 'حاشیه‌نویسی‌های متنی',
    toolbarAnnotationsTextColor: 'رنگ متن',
    toolbarAnnotationsTextSize: 'اندازه متن',
    toolbarAnnotationsTrendLine: 'خط روند',
    toolbarAnnotationsUnlock: 'باز کردن',
    toolbarAnnotationsVerticalLine: 'خط عمودی',
    toolbarRange1Month: '۱ ماه',
    toolbarRange1MonthAria: '۱ ماه',
    toolbarRange1Year: '1سال',
    toolbarRange1YearAria: '۱ سال',
    toolbarRange3Months: '۳م',
    toolbarRange3MonthsAria: '۳ ماه',
    toolbarRange6Months: '6ماه',
    toolbarRange6MonthsAria: '۶ ماه',
    toolbarRangeAll: 'همه',
    toolbarRangeAllAria: 'همه',
    toolbarRangeYearToDate: 'از ابتدای سال',
    toolbarRangeYearToDateAria: 'از ابتدای سال تا کنون',
    toolbarSeriesTypeCandles: 'شمع‌ها',
    toolbarSeriesTypeDropdown: 'نوع نمودار',
    toolbarSeriesTypeHighLow: 'بیشترین و کمترین',
    toolbarSeriesTypeHLC: 'HLC',
    toolbarSeriesTypeHollowCandles: 'شمع های توخالی',
    toolbarSeriesTypeLine: 'خط',
    toolbarSeriesTypeLineWithMarkers: 'خط با نشانگرها',
    toolbarSeriesTypeOHLC: 'OHLC',
    toolbarSeriesTypeStepLine: 'گام خط',
    toolbarZoomPanEnd: 'حرکت به انتها',
    toolbarZoomPanLeft: 'حرکت به چپ',
    toolbarZoomPanRight: 'حرکت به راست',
    toolbarZoomPanStart: 'جابجایی به ابتدا',
    toolbarZoomReset: 'بازنشانی بزرگ‌نمایی',
    toolbarZoomZoomIn: 'بزرگنمایی',
    toolbarZoomZoomOut: 'بزرگنمایی کمتر',
    tooltipPaginationStatus: '${index}[number] از ${count}[number]',
};
